import "./token.mjs";
import "ethers";
import "@deorderbook/contracts/abi";
import "../store/provider.mjs";
import "@deorderbook/contracts";
import { useMarketBulletContract as n } from "../store/marketBulletContract.mjs";
import "../store/subgraph.mjs";
async function k(t, e, u, r, i) {
  return await n(!0).offer(
    t,
    e,
    u,
    r,
    i
  );
}
async function w(t, e, u) {
  return await n(!0).update(t, e, u);
}
async function b(t) {
  return await n(!0).buy(t);
}
async function p(t, e, u, r, i) {
  return await n(!0).bulkOffer(
    t,
    e,
    u,
    r,
    i
  );
}
async function B(t) {
  return await n(!0).bulkBuy(t);
}
async function h(t, e, u) {
  return await n(!0).bulkUpdate(t, e, u);
}
async function m(t) {
  return await n(!0).cancel(t);
}
function S() {
  return n().owner();
}
async function W(t, e) {
  return await n().getBestOffer(t, e);
}
async function C(t, e) {
  return await n().getOfferCount(t, e);
}
async function d(t) {
  return await n(!0).bulkCancel(t);
}
async function g(t, e) {
  return await n(!0).setBuyTokenWhitelist(t, e);
}
async function O(t, e) {
  return await n(!0).bulkSetBuyerWhitelist(t, e);
}
function T(t, e) {
  return n(!0).setSellTokenWhitelist(t, e);
}
function F(t, e) {
  return n(!0).bulkSetSellTokenWhitelist(t, e);
}
async function H(...t) {
  return await n(!0).setHandlingFee(...t);
}
async function U(...t) {
  return await n(!0).setFeeCollector(...t);
}
export {
  B as bulkBuy,
  d as bulkCancel,
  p as bulkOffer,
  O as bulkSetBuyerWhitelist,
  F as bulkSetSellTokenWhitelist,
  h as bulkUpdate,
  b as buy,
  m as cancel,
  W as getBestOffer,
  C as getOfferCount,
  k as offer,
  S as owner,
  g as setBuyTokenWhitelist,
  U as setFeeCollector,
  H as setHandlingFee,
  T as setSellTokenWhitelist,
  w as update
};
//# sourceMappingURL=market_bullet.mjs.map
